(() => {
  const audio = document.createElement('audio');
  audio.addEventListener('loadeddata', () => {
    if (audio.readyState < HTMLMediaElement.HAVE_ENOUGH_DATA) {
      return;
    }

    try {
      audio.play().catch(() => {
        // noop
      });
    } catch (e) {
      // noop
    }
  });

  const trigger = (pattern) => {
    let audioFile;
    let vibrationPattern;

    switch (pattern) {
      default:
        return;

      case 'error':
        audioFile = 'error';
        vibrationPattern = [200];
        break;

      case 'press':
        vibrationPattern = [50];
        break;

      case 'notify':
        audioFile = 'notify';
        break;
    }

    if (audioFile) {
      audio.src = `${window.swinger.config.assetsBase}/audio/${audioFile}.mp3?v=${window.swinger.config.version}`;
    }

    if (
      !window.navigator
      || !navigator.vibrate
      || !vibrationPattern
    ) {
      return;
    }

    try {
      navigator.vibrate(vibrationPattern);
    } catch (e) {
      console.error(e);
    }
  };

  document.addEventListener('animationstart', (e) => {
    if (e.animationName !== 'swinger-shake') {
      return;
    }

    trigger('error');
  });

  window.swinger = {
    ...window.swinger,
    audioHapticFeedback: {
      trigger,
    },
  };
})();
